import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Row, Col, Alert, Label, Table, UncontrolledTooltip, Button, Badge, Popover, PopoverBody, Input } from 'reactstrap'
import { Link } from 'react-router-dom'
import { graphql } from '@apollo/client/react/hoc'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import withApolloClient from '../../withApolloClient'
import CustomInputField from '../../Drivers/Driver/Detail/DetailsNew/CustomInputField'
import toTitleCase from "../../Functions/toTitleCase"
import { BILLING_DAYS } from '../../Constants'
import RepAvatar from '../../Material/RepAvatar'
import RenderArgyleGigs from '../Components/RenderArgyleGigs'

import TransactionInfo from "../../Billing/Transactions/TransactionInfo"
import CarIssueModal from "../../Maintenance/CarIssueModal"
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import { cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import { getStatesByCountry, getStateOptions } from '../../utils'
import UpdateIncidentInfo from '../Components/UpdateIncidentInfo'
import MapPicker from '../../Material/MapPicker'
import { HasPermissionsQuery } from '../../Functions/querys'
import AddExternalSystem from '../IncidentModals/AddExternalSystem'
import { formatDuration } from '../../utils'

import './OverviewTab.css'
import RenderUberAccidents from "../Components/RenderUberAccidents"
import FieldHistoryPopover from '../Components/FieldHistoryPopover'

const IncidentDetailQuery = gql`query Incident($incidentId: ID!){
    incident(incidentId:$incidentId){
        id
        pk
        dateAdded
        incidentDate
        incidentTime
        incidentType
        notificationDate
        reportedBy
        metadata
        isArchived
        incidentState
        dmvPlate
        carOnHold
        carTotaled
        ridesharePlatform
        ridesharePeriod
        ridesharePeriodSource
        rideshareIncidentId
        responsibleParty
        source
        status
        location
        hasPoliceReport
        hasDashcamVideos
        hasOtherParties
        hasLiabilityClaim
        hasSubroClaim
        isRecordOnly
        description
        notes
        canChangeBranch
        canAddDriver
        history {
            date
            user
            comment
        }
        branch {
            id
            name
            stateCode
            customId
            tenant {
                id
                customId
            }
        }
        assignedTo {
            edges {
                node {
                    id
                    pk
                    username
                    firstName
                    lastName
                }
            }
        }
        driver {
            id
            pk
            name
            balance
            stage
            tlcLicense
            dmvLicense
            phone
            email
            chargeDayofweek
            currentAgreement {
                id
            }
            branch{
                id
                name
            }
        }
        carCondition {
            id
            pk
        }
        incidentpartySet(isArchived:false) {
            edges {
                node {
                    id
                    isDefault
                    incidentpartypeopleSet(isArchived:false) {
                        edges {
                            node {
                                id
                                role
                                statement
                            }
                        }
                    }
                }
            }
        }
        incidentdocumentSet {
            edges {
                node {
                    id
                    documentType{
                        id
                        name
                    }
                }
            }
        }
        damageTransaction {
            id
            pk
            dateAdded
            dynamicAmount
            notes
            linkedPaymentPlan {
                id
                resultantTransactionsSum
            }
            chargeType {
                id
                name
            }
            updates {
                edges {
                    node {
                        id
                        linkedPaymentPlan {
                            id
                            resultantTransactionsSum
                        }
                    }
                }
            }
        }
        incidentdamageSet {
            edges {
                node {
                    id
                    damage {
                        id
                        car {
                            id
                            pk
                        }
                        dateAdded
                        description: notes
                        issueDesc
                        status
                        reportedBy
                        canPickup
                        projectedCost
                        severity
                        pictures {
                            edges {
                                node {
                                    id
                                    dateAdded
                                    pictureUrl
                                    pictureType
                                    description
                                }
                            }
                        }
                        issueCategory {
                            id
                            name: category
                        }
                        vendor {
                            id
                            name
                        }
                    }
                }
            }
        }
        rental{
            id
            pk
            startDate
            endDate
            duration
            agreementType
            depositScheme
            depositAmount
            branch {
                id
                name
            }
            splitAgreement {
                id
                driver {
                    id
                    name
                }
            }
        }
        car {
            id
            pk
            year
            color
            vin
            notes
            branch {
                id
                name
            }
            carModel {
                id
                make
                name
                groupType {
                    id
                    name
                }
            }
            plate {
                id
                dmvPlate
                fhv
            }
        }
    }
    ridesharePlatformChoices: __type(name: "IncidentsIncidentRidesharePlatformChoices") {
        enumValues {
            name
            description
        }
    }
    ridesharePeriodChoices: __type(name: "IncidentsIncidentRidesharePeriodChoices") {
        enumValues {
            name
            description
        }
    }
    ridesharePeriodSourceChoices: __type(name: "IncidentsIncidentRidesharePeriodSourceChoices") {
        enumValues {
            name
            description
        }
    }
    responsiblePartyChoices: __type(name: "IncidentsIncidentResponsiblePartyChoices") {
        enumValues {
            name
            description
        }
    }
    sourceChoices: __type(name: "IncidentsIncidentSourceChoices") {
        enumValues {
            name
            description
        }
    }
    statusChoices: __type(name: "IncidentsIncidentStatusChoices") {
        enumValues {
            name
            description
        }
    }
    reportedByChoices: __type(name: "IncidentsIncidentReportedByChoices") {
        enumValues {
            name
            description
        }
    }
    carIssueSeverityLevels: __type(name: "CarsCarIssuesSeverityChoices") {
        enumValues {
            name
            description
        }
    }
    incidentTypeChoices: __type(name: "IncidentsIncidentIncidentTypeChoices") {
        enumValues {
            name
            description
        }
    }
    carTotaledChoices: __type(name: "IncidentsIncidentCarTotaledChoices") {
        enumValues {
            name
            description
        }
    }
    incidentNodeFieldDescriptions: __type(name: "IncidentNode") {
        fields {
           name
           description
        }
    } 
    branchOptions: allBranches(isActive:true) {
        edges {
            node {
                id
                name
            }
        }
    }
}`

const ISSUES_TABLE = [
    { id: "date_addded", name: "Date Added", sortable: true },
    { id: "issueCategory", name: "Category", sortable: false },
    { id: "status", name: "Status", sortable: false },
    { id: "projectedCost", name: "Projected Cost", sortable: false },
    { id: "severity", name: "Severity Level", sortable: false },
    { id: "canPickup", name: "Can Pickup", sortable: false },
    { id: "pictures", name: "Pictures", sortable: false },
    { id: "action", name: "Action", sortable: false },
]

const UpdateIncident = gql`
    mutation updateIncidentMutation($input: UpdateIncidentMutationInput!){
    updateIncident(input:$input){
        ok
        errors{
            field
            messages
        }
    }
} `

const UpdateIncidentPartyPeople = gql`
    mutation UpdateIncidentPartyPeopleMutation($input: UpdateIncidentPartyPeopleMutationInput!) {
        updateIncidentPartyPeople(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`

const parseIncidentDateTime = (incidentDate, incidentTime) => {
    if (!incidentDate) return null

    if (incidentTime) {
        const parsedDateTime = moment(`${incidentDate}T${incidentTime}`)
        if (parsedDateTime.isValid()) return parsedDateTime
    }

    const parsedDate = moment(incidentDate)
    return parsedDate.isValid() ? parsedDate.startOf("day") : null
}

const getAgreementDateMismatch = ({ incidentDate, incidentTime, rental }) => {
    if (!incidentDate || !rental?.startDate) {
        return { isApplicable: false, hasMismatch: false }
    }

    const incidentDateTime = parseIncidentDateTime(incidentDate, incidentTime)
    const rentalStart = moment(rental.startDate)
    const rentalEnd = rental.endDate ? moment(rental.endDate) : null

    if (!incidentDateTime || !incidentDateTime.isValid() || !rentalStart.isValid()) {
        return { isApplicable: false, hasMismatch: false }
    }

    const compareDateTime = incidentTime ? incidentDateTime.clone() : incidentDateTime.clone().startOf("day")
    const compareStart = rentalStart.clone()
    const compareEnd = rentalEnd ? rentalEnd.clone() : null

    const startBoundary = incidentTime ? compareStart : compareStart.startOf("day")
    const endBoundary = compareEnd ? (incidentTime ? compareEnd : compareEnd.endOf("day")) : null
    const isWithinAgreementWindow = compareDateTime.isSameOrAfter(startBoundary) && (!endBoundary || compareDateTime.isSameOrBefore(endBoundary))

    return {
        isApplicable: true,
        hasMismatch: !isWithinAgreementWindow,
        incidentDateTime: compareDateTime,
        showIncidentTime: Boolean(incidentTime),
        rentalStart: compareStart,
        rentalEnd: compareEnd,
    }
}



class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            loading: false,
            openModal: "",
            editField: "",
            fieldLoading: {},
            inputValues: {},
            originalValues: {},
            fieldErrors: {},
            incidentDamageTab: "#incidentDamages",
            selectedDamages: [],
        }
    }

    editField = (fieldName, fieldValue = "") => {
        if (this.state.editField && this.state.editField !== fieldName) {
            this.setState(prev => ({
                fieldErrors: { ...prev.fieldErrors, [fieldName]: "Please save or cancel the current edit before editing this field." }
            }))
            return
        }
        this.setState(prevState => ({
            editField: fieldName,
            inputValues: {
                ...prevState.inputValues,
                [fieldName]: fieldValue
            },
            originalValues: {
                ...prevState.originalValues,
                [fieldName]: fieldValue
            },
            error: null
        }))
    }

    saveField = (fieldName, fieldValue) => {
        if (fieldValue === undefined || fieldValue === null || fieldValue === "") {
            this.cancelEdit()
            return
        }
        if (this.state.fieldErrors[fieldName]) return
        this.updateIncidents(this.props.id, fieldName, fieldValue)
    }

    updateIncidents = async (incidentId, name, value) => {
        const trimmedValue = typeof value === 'string' ? value.trim() : value

        if (trimmedValue === this.state.originalValues[name]) {
            this.cancelEdit()
            return
        }

        const isValidValue = typeof trimmedValue === "boolean" || Boolean(trimmedValue)
        if (!incidentId || !name || !isValidValue) return

        this.setState({
            fieldLoading: { ...this.state.fieldLoading, [name]: true },
            error: "",
            fieldErrors: { ...this.state.fieldErrors, [name]: "" },
        })

        const input = {
            incidentId: incidentId,
            [name]: trimmedValue,
        }

        try {
            const result = await this.props.apolloClient.mutate({
                mutation: UpdateIncident,
                variables: { input },
            })

            const { ok, errors } = result?.data?.updateIncident || {}

            if (ok) {
                this.setState((prev) => ({
                    editField: "",
                    error: "",
                    inputValues: { ...prev.inputValues, [name]: trimmedValue },
                    originalValues: { ...prev.originalValues, [name]: trimmedValue },
                    fieldErrors: { ...prev.fieldErrors, [name]: "" },
                }))
                this.props.overviewTabRefetchQuery()
                this.props.refetchQuery()
            } else {
                const errorMessage = errors?.[0]?.messages?.toString() || "Something went wrong, Please contact admin for support!"
                this.setState((prev) => ({
                    error: errorMessage,
                    fieldErrors: { ...prev.fieldErrors, [name]: errorMessage },
                    editField: name,
                }))
            }
        } catch (err) {
            this.setState((prev) => ({
                error: err.message,
                fieldErrors: { ...prev.fieldErrors, [name]: err.message },
                editField: name,
            }))
        } finally {
            this.setState((prev) => ({
                fieldLoading: { ...prev.fieldLoading, [name]: false },
            }))
        }
    };

    updateDriverStatement = async (partyPeopleId, fieldValue) => {
        const fieldName = "driverStatement"
        const trimmedValue = typeof fieldValue === "string" ? fieldValue.trim() : fieldValue

        if (trimmedValue === this.state.originalValues[fieldName]) {
            this.cancelEdit()
            return
        }

        if (!partyPeopleId || !trimmedValue || this.state.fieldErrors[fieldName]) return

        this.setState((prev) => ({
            fieldLoading: { ...prev.fieldLoading, [fieldName]: true },
            error: "",
            fieldErrors: { ...prev.fieldErrors, [fieldName]: "" },
        }))

        try {
            const result = await this.props.apolloClient.mutate({
                mutation: UpdateIncidentPartyPeople,
                variables: {
                    input: {
                        partyPeopleId,
                        statement: trimmedValue,
                    },
                },
            })
            if (result?.data?.updateIncidentPartyPeople?.ok) {
                this.setState((prev) => ({
                    editField: "",
                    error: "",
                    inputValues: { ...prev.inputValues, [fieldName]: trimmedValue },
                    originalValues: { ...prev.originalValues, [fieldName]: trimmedValue },
                    fieldErrors: { ...prev.fieldErrors, [fieldName]: "" },
                }))
                this.props.overviewTabRefetchQuery()
                this.props.refetchQuery()
            } else {
                const errorMessage = result?.data?.updateIncidentPartyPeople?.errors?.[0]?.messages?.toString() || "Something went wrong, Please contact admin for support!"
                this.setState((prev) => ({
                    error: errorMessage,
                    fieldErrors: { ...prev.fieldErrors, [fieldName]: errorMessage },
                    editField: fieldName,
                }))
            }
        } catch (err) {
            this.setState((prev) => ({
                error: err.message,
                fieldErrors: { ...prev.fieldErrors, [fieldName]: err.message },
                editField: fieldName,
            }))
        } finally {
            this.setState((prev) => ({
                fieldLoading: { ...prev.fieldLoading, [fieldName]: false },
            }))
        }
    }

    cancelEdit = () => {
        if (!this.state.editField) return
        this.setState({
            editField: "",
            inputValues: {},
            originalValues: {},
            fieldErrors: {},
            error: "",
            fieldLoading: {},
        })
    }

    updateInput = (e) => {
        this.setState({ error: "", fieldErrors: { ...this.state.fieldErrors, [e.target.name]: "" } })
        const rawValue = e.target.value
        const fieldName = e.target.name
        const fieldType = e.target.type

        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [fieldName]: fieldType === "select-one" ? rawValue === "true" ? true : rawValue === "false" ? false : rawValue : rawValue
            }
        }))
    }

    pObj = (jsonString) => {
        let obj = JSON.parse(jsonString)
        return obj
    }

    viewPictures = (carPictures, index = 0) => {
        let pictures = carPictures?.map(picture => ({ documentUrl: cleanDocumentUrl(picture.node.pictureUrl), id: picture.node.id, name: toTitleCase(picture.node.pictureType), description: picture.node.description, dateAdded: picture.node.dateAdded }))
        this.setState({ carPictures: pictures, selectedImage: pictures[index] })
    }
    next = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === carPictures.length - 1) return
        this.setState({ selectedImage: carPictures[currentIndex + 1] })
    }
    prev = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === 0) return
        this.setState({ selectedImage: carPictures[currentIndex - 1] })
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "", error: "" })
        } else {
            this.setState({ openModal: modalName, error: "" })
        }
    }

    handleDamageSelection = (damageId) => {
        if (this.state.selectedDamages?.includes(damageId)) {
            this.setState(prevState => ({
                selectedDamages: prevState.selectedDamages.filter(id => id !== damageId)
            }))
        } else {
            this.setState(prevState => ({
                selectedDamages: [...prevState.selectedDamages, damageId]
            }))
        }
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: "",
            openModal: "",
            selectedDamages: [],
        })
    }

    render() {
        const fieldDescriptions = this.props.incidentNodeFieldDescriptions?.fields.reduce((acc, field) => {
            acc[field.name] = field.description
            return acc
        }, {})

        // Map enum values to options with label and value
        const mapEnumToOptions = (enumValues) => {
            return enumValues?.map(({ name, description }) => ({
                value: name,
                label: description || name
            }))
        }

        const ridesharePlatformOptions = mapEnumToOptions(this.props.ridesharePlatformChoices?.enumValues)
        const ridesharePeriodOptions = mapEnumToOptions(this.props.ridesharePeriodChoices?.enumValues)
        const ridesharePeriodSourceOptions = mapEnumToOptions(this.props.ridesharePeriodSourceChoices?.enumValues)
        const responsiblePartyOptions = mapEnumToOptions(this.props.responsiblePartyChoices?.enumValues)
        const sourceOptions = mapEnumToOptions(this.props.sourceChoices?.enumValues)
        const statusOptions = mapEnumToOptions(this.props.statusChoices?.enumValues)
        const reportedByOptions = mapEnumToOptions(this.props.reportedByChoices?.enumValues)
        const incidentTypeOptions = mapEnumToOptions(this.props.incidentTypeChoices?.enumValues)
        const carTotaledOptions = mapEnumToOptions(this.props.carTotaledChoices?.enumValues)
        const booleanOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }]
        const rental = this.props.incident?.rental
        const driver = this.props.incident?.driver
        const car = this.props.incident?.car
        const driverInvoiceDay = driver
            ? BILLING_DAYS.find((day) => day.value === driver.chargeDayofweek)?.label || "---"
            : "---"
        const carDisplayName = car?.pk
            ? `#${car.pk} - ${car?.year || "--"} ${toTitleCase(car?.carModel?.make || "--")} ${toTitleCase(car?.carModel?.name || "--")}`
            : "--"
        const rentalDepositLabel = rental
            ? `${toTitleCase(rental?.depositScheme) || "--"}${rental?.depositAmount !== null && rental?.depositAmount !== undefined ? ` - $${rental.depositAmount}` : ""}`
            : "--"
        const agreementDateMismatch = getAgreementDateMismatch({
            incidentDate: this.props.incident?.incidentDate,
            incidentTime: this.props.incident?.incidentTime,
            rental,
        })
        const states = getStatesByCountry("us")
        const stateOptions = getStateOptions(states)
        const branchOptions = this.props.branchOptions?.edges?.map(({ node }) => ({
            value: node.id,
            label: node.name,
        })) || []
        const defaultParty = this.props.incident?.incidentpartySet?.edges?.map(({ node }) => node).find((party) => party?.isDefault)
        const defaultPartyDriver = defaultParty?.incidentpartypeopleSet?.edges?.map(({ node }) => node).find((person) => person?.role === "VEHICLE_DRIVER")

        const metadata = this.props.incident?.metadata ? JSON.parse(this.props.incident.metadata) : {}
        const externalSystems = metadata.external_ids || {}
        const crmId = metadata.crm_id || null
        const crmTitle = metadata.crm_name || null
        const mondayItemId = metadata.monday_row_id || null
        const mondayRowTitle = metadata.monday_row_title || null
        const mondayItemId_1 = metadata.monday_row_id_1 || null
        const mondayRowTitle_1 = metadata.monday_row_title_1 || null
        const crmNotes = Array.isArray(metadata.crm_notes) ? metadata.crm_notes : []
        // const liabilityClaims = this.props.incident?.liabilityclaimSet?.edges?.map(({ node }) => node) || []
        // const latestLiabilityClaim = liabilityClaims.filter(claim => claim?.dateAdded).sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded))[0] || liabilityClaims[0] || null

        return (
            <div className="overview-tab-container">
                {this.state.selectedImage &&
                    <DocumentModalNew
                        document={this.state.selectedImage}
                        handleClose={() => this.setState({ selectedImage: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"car"}
                        isPicture={true}
                        refetch={this.props.overviewTabRefetchQuery}
                        currentUser={this.props.currentUser}
                    />
                }
                <Row>
                    <Col xs="12" className="pb-2">
                        {agreementDateMismatch.isApplicable && agreementDateMismatch.hasMismatch && (
                            <Alert color="danger" className="overview-agreement-warning" role="alert">
                                <div className="overview-agreement-warning__title">
                                    <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                                    <span>Agreement date mismatch</span>
                                </div>
                                <div className="overview-agreement-warning__body">
                                    The incident timestamp does not fall within the agreement window. Please verify that the incident is linked to the correct agreement.
                                </div>
                                <div className="overview-agreement-warning__details">
                                    <div>
                                        <span>Incident Date</span>{" "}
                                        {agreementDateMismatch.incidentDateTime
                                            ? agreementDateMismatch.showIncidentTime
                                                ? agreementDateMismatch.incidentDateTime.format("MMM D, YYYY hh:mm A")
                                                : agreementDateMismatch.incidentDateTime.format("MMM D, YYYY")
                                            : "--"}
                                    </div>
                                    <div><span>Rental Start</span> {agreementDateMismatch.rentalStart ? agreementDateMismatch.rentalStart.format("MMM D, YYYY hh:mm A") : "--"}</div>
                                    <div><span>Rental End</span> {agreementDateMismatch.rentalEnd ? agreementDateMismatch.rentalEnd.format("MMM D, YYYY hh:mm A") : "ACTIVE"}</div>
                                </div>
                            </Alert>
                        )}
                        {/* {latestLiabilityClaim && (
                            <div className="overview-latest-claim-card mb-4">
                                <div className="overview-latest-claim-card__top">
                                    <div>
                                        <div className="overview-latest-claim-card__eyebrow">Latest Liability Claim</div>
                                        <div className="overview-latest-claim-card__title">
                                            <span className="overview-latest-claim-card__id" title="VGM ID">#{latestLiabilityClaim.pk}</span>
                                            <span className="overview-latest-claim-card__claim-number" title="Claim Number">
                                                {latestLiabilityClaim.externalId || "--"}
                                            </span>
                                            {latestLiabilityClaim.externalId && (
                                                <CopyToClipboard textToCopy={latestLiabilityClaim.externalId} displayText="claim number" />
                                            )}
                                        </div>
                                        <div className="overview-latest-claim-card__meta">
                                            <span className="overview-latest-claim-card__meta-pill" title="TPA Name">
                                                <i className="fa fa-building-o" aria-hidden="true" />
                                                {toTitleCase(latestLiabilityClaim?.tpa?.name) || "--"}
                                            </span>
                                            <span className="overview-latest-claim-card__meta-text">
                                                Added {latestLiabilityClaim.dateAdded ? <DatetimeRenderer datetime={latestLiabilityClaim.dateAdded} /> : "--"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="overview-latest-claim-card__status-wrap">
                                        <div className="overview-latest-claim-card__label">Status</div>
                                        <Badge className="claims-row__status--badges text-uppercase">
                                            {toTitleCase(latestLiabilityClaim.status) || '--'}
                                        </Badge>
                                    </div>
                                </div>
                                <div className="overview-latest-claim-card__stats">
                                    <div className="overview-latest-claim-stat">
                                        <div className="overview-latest-claim-stat__label">Acknowledgment Date</div>
                                        <div className="overview-latest-claim-stat__value">
                                            {latestLiabilityClaim.acknowledgmentDate ? moment(latestLiabilityClaim.acknowledgmentDate).format('MM/DD/YYYY') : '--'}
                                        </div>
                                    </div>
                                    <div className="overview-latest-claim-stat">
                                        <div className="overview-latest-claim-stat__label">Filed Date</div>
                                        <div className="overview-latest-claim-stat__value">
                                            {latestLiabilityClaim.filedDate ? moment(latestLiabilityClaim.filedDate).format('MM/DD/YYYY') : '--'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}
                        <div className="incident-overview-header">
                            <div className="incident-overview-header__titles">
                                <h3 className="incident-overview-header__title">Incident Overview</h3>
                                <p className="incident-overview-header__subtitle">Key details, driver, vehicle and rental information for this incident.</p>
                            </div>
                        </div>
                        <div className='info-container'>
                            {!this.state.editField && this.state.error && <Row>
                                <Col>
                                    <Alert color="danger" className="mt-2 mb-0">{this.state.error}</Alert>
                                </Col>
                            </Row>}
                            <Row>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <>
                                        <CustomInputField
                                            label="Incident Date"
                                            fieldName="incidentDate"
                                            fieldDescription={fieldDescriptions?.incidentDate}
                                            showCopyIcon={false}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            inputType="date"
                                            error={this.state.fieldErrors?.incidentDate || null}
                                            isEditing={this.state.editField === "incidentDate"}
                                            isLoading={!!this.state.fieldLoading.incidentDate}
                                            inputValue={(this.state.inputValues.incidentDate || this.props.incident?.incidentDate) ? moment(this.state.inputValues.incidentDate || this.props.incident?.incidentDate).format("YYYY-MM-DD") : null}
                                            currentValue={this.props.incident?.incidentDate ? moment(this.props.incident?.incidentDate).format("YYYY-MM-DD") : null}
                                            maxValue={moment().format("YYYY-MM-DD")}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    </>
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Time"
                                        fieldName="incidentTime"
                                        fieldDescription={fieldDescriptions?.incidentTime}
                                        showCopyIcon={false}
                                        inputType="time"
                                        error={this.state.fieldErrors?.incidentTime || null}
                                        isEditing={this.state.editField === "incidentTime"}
                                        isLoading={!!this.state.fieldLoading.incidentTime}
                                        inputValue={(this.state.inputValues.incidentTime || this.props.incident?.incidentTime) ? moment(this.state.inputValues.incidentTime || this.props.incident?.incidentTime, "HH:mm:ss").format("HH:mm") : null}
                                        currentValue={this.props.incident?.incidentTime ? moment(this.props.incident?.incidentTime, "HH:mm:ss").format("hh:mm A") : null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />}
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Notification Datetime"
                                        fieldName="notificationDatetime"
                                        id="notificationDatetime"
                                        fieldDescription={fieldDescriptions?.notificationDate}
                                        showCopyIcon={false}
                                        error={this.state.fieldErrors?.notificationDatetime || null}
                                        inputType={"datetime-local"}
                                        currentValue={this.props.incident?.notificationDate}
                                        inputValue={this.props.incident?.notificationDate}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        driverId={this.props.incident?.driver?.id}
                                        branchId={this.props.incident?.branch?.id || this.props.incident?.driver?.branch?.id || this.props.incident?.rental?.branch?.id || this.props.incident?.car?.branch?.id}
                                        onEdit={() => this.toggleModal("notificationDatetime")}
                                        renderEditingModal={() =>
                                            this.state.openModal === "notificationDatetime" &&
                                            <UpdateIncidentInfo
                                                title="Edit Incident Notification Datetime"
                                                name="notificationDatetime"
                                                type="datetime-local"
                                                value={this.props.incident?.notificationDate}
                                                min={this.props.incident?.incidentDate}
                                                max={moment()}
                                                open={this.state.openModal === "notificationDatetime"}
                                                target="notificationDatetime"
                                                handleClose={() => this.toggleModal("")}
                                                incidentId={this.props.incident?.id}
                                                refetchIncident={this.props.overviewTabRefetchQuery}
                                                branchId={this.props.incident?.branch?.id || this.props.incident?.driver?.branch?.id || this.props.incident?.rental?.branch?.id || this.props.incident?.car?.branch?.id}
                                            />
                                        }
                                    />
                                }
                                <Col>
                                    <Row>
                                        <Col xs="9">
                                            <Label>Assigned To</Label>
                                        </Col>
                                        <Col xs="3" className="text-right">
                                            {!this.props.incident?.isArchived && <i id={`assignedToEdit${this.props.incident?.pk}`} className="fa fa-lg fa-pencil-square cursor-pointer" onClick={() => this.editField("assignedTo")} title="Edit" />}

                                            {this.state.editField === "assignedTo" &&
                                                <UpdateIncidentInfo
                                                    title="Edit Assigned To"
                                                    name="assignedToIds"
                                                    type="select"
                                                    open={this.state.editField === "assignedTo"}
                                                    value={this.props.incident?.assignedTo?.edges?.map(e => e.node) || []}
                                                    target={`assignedToEdit${this.props.incident?.pk}`}
                                                    handleClose={this.cancelEdit}
                                                    incidentId={this.props.incident?.id}
                                                    refetchIncident={this.props.overviewTabRefetchQuery}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            {this.props.incident?.assignedTo?.edges?.length > 0 ? this.props.incident?.assignedTo?.edges.map(e => <RepAvatar key={e.node.id} rep={e.node} />) : <RepAvatar />}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Status"
                                        fieldName="status"
                                        fieldDescription={fieldDescriptions?.status}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.status || null}
                                        options={statusOptions}
                                        isEditing={this.state.editField === "status"}
                                        isLoading={!!this.state.fieldLoading.status}
                                        inputValue={this.state.inputValues.status || this.props.incident?.status}
                                        currentValue={this.props.incident?.status}
                                        showEditIcon={!this.props.incident?.isRecordOnly && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                        customCssClass={"border border-warning"}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Reported By"
                                        fieldName="reportedBy"
                                        fieldDescription={fieldDescriptions?.reportedBy}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.reportedBy || null}
                                        options={reportedByOptions}
                                        isEditing={this.state.editField === "reportedBy"}
                                        isLoading={!!this.state.fieldLoading.reportedBy}
                                        inputValue={this.state.inputValues.reportedBy || this.props.incident?.reportedBy}
                                        currentValue={this.props.incident?.reportedBy}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Source"
                                        fieldName="source"
                                        fieldDescription={fieldDescriptions?.source}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.source || null}
                                        options={sourceOptions}
                                        isEditing={this.state.editField === "source"}
                                        isLoading={!!this.state.fieldLoading.source}
                                        inputValue={this.state.inputValues.source || this.props.incident?.source}
                                        currentValue={this.props.incident?.source}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Type"
                                        fieldName="incidentType"
                                        fieldDescription={fieldDescriptions?.incidentType}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.incidentType || null}
                                        options={incidentTypeOptions}
                                        isEditing={this.state.editField === "incidentType"}
                                        isLoading={!!this.state.fieldLoading.incidentType}
                                        inputValue={this.state.inputValues.incidentType || this.props.incident?.incidentType}
                                        currentValue={this.props.incident?.incidentType || null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="DMV Plate"
                                        fieldName="dmvPlate"
                                        fieldDescription={fieldDescriptions?.dmvPlate}
                                        showCopyIcon={false}
                                        inputType="text"
                                        // inputValue={this.state.inputValues.dmvPlate || this.props.incident?.dmvPlate}
                                        // currentValue={this.props.incident?.dmvPlate}
                                        // showEditIcon={true}
                                        error={this.state.fieldErrors?.dmvPlate || null}
                                        options={booleanOptions}
                                        isEditing={this.state.editField === "dmvPlate"}
                                        isLoading={!!this.state.fieldLoading.dmvPlate}
                                        inputValue={this.state.inputValues.dmvPlate !== undefined ? this.state.inputValues.dmvPlate : this.props.incident?.dmvPlate}
                                        currentValue={this.props.incident?.dmvPlate !== undefined ? this.props.incident?.dmvPlate : "--"}
                                        showEditIcon={!this.props.incident?.isArchived && this.props.hasPermissions?.includes("change_incident_sensitive_data")}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}

                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Is Record Only?"
                                        fieldName="isRecordOnly"
                                        fieldDescription={fieldDescriptions?.isRecordOnly}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.isRecordOnly || null}
                                        options={booleanOptions}
                                        isEditing={this.state.editField === "isRecordOnly"}
                                        isLoading={!!this.state.fieldLoading.isRecordOnly}
                                        inputValue={this.state.inputValues.isRecordOnly !== undefined ? this.state.inputValues.isRecordOnly : this.props.incident?.isRecordOnly}
                                        currentValue={this.props.incident?.isRecordOnly !== undefined ? this.props.incident?.isRecordOnly : "--"}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Location"
                                        fieldName="location"
                                        fieldDescription={fieldDescriptions?.location}
                                        showCopyIcon={false}
                                        inputType="text"
                                        error={this.state.fieldErrors?.location || null}
                                        isEditing={this.state.editField === "location"}
                                        isLoading={!!this.state.fieldLoading.location}
                                        inputValue={this.state.inputValues.location || this.props.incident?.location}
                                        currentValue={this.props.incident?.location}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                        renderEditingModal={() =>
                                            this.state.editField === "location" &&
                                            <Popover trigger="legacy" placement="left" isOpen={true} target="location" toggle={this.cancelEdit} style={{ minWidth: "350px" }}>
                                                <PopoverBody>
                                                    <MapPicker
                                                        initialLocation={this.props.incident?.location || ""}
                                                        onLocationSelect={(loc) => {
                                                            this.setState(prevState => ({
                                                                inputValues: {
                                                                    ...prevState.inputValues,
                                                                    location: loc.address || "",
                                                                    incidentState: loc.state || prevState.inputValues.incidentState
                                                                }
                                                            }))
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-end">
                                                        <Button
                                                            color="primary"
                                                            className="mt-2 mb-2"
                                                            onClick={() => {
                                                                this.saveField("location", this.state.inputValues.location)
                                                                setTimeout(() => {
                                                                    this.saveField("incidentState", this.state.inputValues.incidentState)
                                                                }, 100)
                                                            }}
                                                            disabled={!!this.state.fieldLoading.location || !!this.state.fieldLoading.incidentState}
                                                        >
                                                            {(!!this.state.fieldLoading.location || !!this.state.fieldLoading.incidentState) ? "Saving..." : "Save"}
                                                        </Button>
                                                    </div>
                                                </PopoverBody>
                                            </Popover>
                                        }
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident State"
                                        fieldName="incidentState"
                                        fieldDescription={fieldDescriptions?.incidentState}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.incidentState || null}
                                        options={stateOptions}
                                        isEditing={this.state.editField === "incidentState"}
                                        isLoading={!!this.state.fieldLoading.incidentState}
                                        inputValue={this.state.inputValues.incidentState || this.props.incident?.incidentState}
                                        currentValue={this.props.incident?.incidentState}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Rideshare Period"
                                        fieldName="ridesharePeriod"
                                        fieldDescription={fieldDescriptions?.ridesharePeriod}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.ridesharePeriod || null}
                                        options={ridesharePeriodOptions}
                                        isEditing={this.state.editField === "ridesharePeriod"}
                                        isLoading={!!this.state.fieldLoading.ridesharePeriod}
                                        inputValue={this.state.inputValues.ridesharePeriod || this.props.incident?.ridesharePeriod}
                                        currentValue={this.props.incident?.ridesharePeriod}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {this.props.incident?.ridesharePeriod && !["X", "ZERO"].includes(this.props.incident?.ridesharePeriod) && <>
                                    {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                        <CustomInputField
                                            label="Rideshare Platform"
                                            fieldName="ridesharePlatform"
                                            fieldDescription={fieldDescriptions?.ridesharePlatform}
                                            showCopyIcon={false}
                                            inputType="select"
                                            error={this.state.fieldErrors?.ridesharePlatform || null}
                                            options={ridesharePlatformOptions}
                                            isEditing={this.state.editField === "ridesharePlatform"}
                                            isLoading={!!this.state.fieldLoading.ridesharePlatform}
                                            inputValue={this.state.inputValues.ridesharePlatform || this.props.incident?.ridesharePlatform}
                                            currentValue={this.props.incident?.ridesharePlatform}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    }
                                    {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                        <CustomInputField
                                            label="Rideshare Period Source"
                                            fieldName="ridesharePeriodSource"
                                            fieldDescription={fieldDescriptions?.ridesharePeriodSource}
                                            showCopyIcon={false}
                                            inputType="select"
                                            error={this.state.fieldErrors?.ridesharePeriodSource || null}
                                            options={ridesharePeriodSourceOptions}
                                            isEditing={this.state.editField === "ridesharePeriodSource"}
                                            isLoading={!!this.state.fieldLoading.ridesharePeriodSource}
                                            inputValue={this.state.inputValues.ridesharePeriodSource || this.props.incident?.ridesharePeriodSource}
                                            currentValue={this.props.incident?.ridesharePeriodSource}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    }
                                    {this.props.incident?.ridesharePlatform && this.props.incident.ridesharePeriodSource && <>
                                        {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                            <CustomInputField
                                                label="Rideshare Incident ID"
                                                fieldName="rideshareIncidentId"
                                                fieldDescription={fieldDescriptions?.rideshareIncidentId}
                                                showCopyIcon={false}
                                                inputType="text"
                                                error={this.state.fieldErrors?.rideshareIncidentId || null}
                                                isEditing={this.state.editField === "rideshareIncidentId"}
                                                isLoading={!!this.state.fieldLoading.rideshareIncidentId}
                                                inputValue={this.state.inputValues.rideshareIncidentId || this.props.incident?.rideshareIncidentId}
                                                currentValue={this.props.incident?.rideshareIncidentId}
                                                showEditIcon={!this.props.incident?.isArchived}
                                                onEdit={this.editField}
                                                onSave={this.saveField}
                                                onChange={this.updateInput}
                                                onCancel={this.cancelEdit}
                                            />
                                        }
                                    </>
                                    }
                                </>}
                            </Row>

                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        colSize={3}
                                        label="Responsible Party"
                                        fieldName="responsibleParty"
                                        fieldDescription={fieldDescriptions?.responsibleParty}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.responsibleParty || null}
                                        options={responsiblePartyOptions}
                                        isEditing={this.state.editField === "responsibleParty"}
                                        isLoading={!!this.state.fieldLoading.responsibleParty}
                                        inputValue={this.state.inputValues.responsibleParty || this.props.incident?.responsibleParty}
                                        currentValue={this.props.incident?.responsibleParty}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Dashcam Videos?"
                                        fieldName="hasDashcamVideos"
                                        fieldDescription={fieldDescriptions?.hasDashcamVideos}
                                        showCopyIcon={false}
                                        inputType='select'
                                        error={this.state.fieldErrors?.hasDashcamVideos || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasDashcamVideos"}
                                        isLoading={!!this.state.fieldLoading.hasDashcamVideos}
                                        inputValue={this.state.inputValues.hasDashcamVideos !== undefined ? this.state.inputValues.hasDashcamVideos : this.props.incident?.hasDashcamVideos}
                                        currentValue={this.props.incident?.hasDashcamVideos}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }

                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Police Report?"
                                        fieldName="hasPoliceReport"
                                        fieldDescription={fieldDescriptions?.hasPoliceReport}
                                        showCopyIcon={false}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasPoliceReport || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasPoliceReport"}
                                        inputValue={this.state.inputValues.hasPoliceReport !== undefined ? this.state.inputValues.hasPoliceReport : this.props.incident?.hasPoliceReport}
                                        currentValue={this.props.incident?.hasPoliceReport}
                                        isLoading={!!this.state.fieldLoading.hasPoliceReport}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        showEditIcon={!this.props.incident?.isArchived}
                                        label="Has Other Parties?"
                                        fieldName="hasOtherParties"
                                        fieldDescription={fieldDescriptions?.hasOtherParties}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasOtherParties || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasOtherParties"}
                                        isLoading={!!this.state.fieldLoading.hasOtherParties}
                                        inputValue={this.state.inputValues.hasOtherParties !== undefined ? this.state.inputValues.hasOtherParties : this.props.incident?.hasOtherParties}
                                        currentValue={this.props.incident?.hasOtherParties}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Liability Claim?"
                                        fieldName="hasLiabilityClaim"
                                        fieldDescription={fieldDescriptions?.hasLiabilityClaim}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasLiabilityClaim || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasLiabilityClaim"}
                                        isLoading={!!this.state.fieldLoading.hasLiabilityClaim}
                                        inputValue={this.state.inputValues.hasLiabilityClaim || this.props.incident?.hasLiabilityClaim}
                                        currentValue={this.props.incident?.hasLiabilityClaim}
                                        showEditIcon={!this.props.incident?.isArchived && this.props.incident?.incidentDate}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Subro Claim?"
                                        fieldName="hasSubroClaim"
                                        fieldDescription={fieldDescriptions?.hasSubroClaim}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasSubroClaim || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasSubroClaim"}
                                        isLoading={!!this.state.fieldLoading.hasSubroClaim}
                                        inputValue={this.state.inputValues.hasSubroClaim || this.props.incident?.hasSubroClaim}
                                        currentValue={this.props.incident?.hasSubroClaim}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Car Totaled"
                                        fieldName="carTotaled"
                                        fieldDescription={fieldDescriptions?.carTotaled}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.carTotaled || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "carTotaled"}
                                        isLoading={!!this.state.fieldLoading.carTotaled}
                                        inputValue={this.state.inputValues.carTotaled !== undefined ? this.state.inputValues.carTotaled : this.props.incident?.carTotaled}
                                        currentValue={this.props.incident?.carTotaled !== undefined ? this.props.incident?.carTotaled : null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Car On Hold"
                                        fieldName="carOnHold"
                                        fieldDescription={fieldDescriptions?.carOnHold}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.carOnHold || null}
                                        options={booleanOptions}
                                        isEditing={this.state.editField === "carOnHold"}
                                        isLoading={!!this.state.fieldLoading.carOnHold}
                                        inputValue={this.state.inputValues.carOnHold !== undefined ? this.state.inputValues.carOnHold : this.props.incident?.carOnHold}
                                        currentValue={this.props.incident?.carOnHold !== undefined ? this.props.incident?.carOnHold : null}
                                        showEditIcon={this.props.hasPermissions?.includes("custom_can_edit_car_on_hold") && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Branch"
                                        fieldName="branchId"
                                        fieldDescription={fieldDescriptions?.branch}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.branchId || null}
                                        options={branchOptions}
                                        isEditing={this.state.editField === "branchId"}
                                        isLoading={!!this.state.fieldLoading.branchId}
                                        inputValue={this.state.inputValues.branchId || this.props.incident?.branch?.id}
                                        currentValue={this.props.incident?.branch?.id || ""}
                                        showEditIcon={this.props.incident?.canChangeBranch && this.props.hasPermissions?.includes("custom_can_change_incident_branch") && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={6}><Skeleton count={1} height={30} /></Col> :
                                    <>
                                        <CustomInputField
                                            showEditIcon={!this.props.incident?.isArchived}
                                            showHistoryIcon={true}
                                            label="Notes"
                                            fieldName="notes"
                                            fieldDescription={fieldDescriptions?.notes}
                                            showCopyIcon={false}
                                            inputType="textarea"
                                            error={this.state.fieldErrors?.notes || null}
                                            isEditing={this.state.editField === "notes"}
                                            isLoading={!!this.state.fieldLoading.notes}
                                            inputValue={this.state.inputValues.notes || this.props.incident?.notes}
                                            currentValue={this.props.incident?.notes}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                            renderAdditionalActions={() =>
                                                <>
                                                    <FieldHistoryPopover title={"Notes"} history={this.props.incident?.history?.filter(item => item.comment.toLowerCase().includes("notes:")) || []} isOpen={this.state.showNotesHistoryModal} target="notes-history" toggle={() => this.setState({ showNotesHistoryModal: false })} />
                                                    <span id={`notes-history`}>
                                                        <i className="fa fa-lg fa-history cursor-pointer" onClick={() => this.setState({ showNotesHistoryModal: true })} title="View History" />
                                                    </span>
                                                    &nbsp;&nbsp;
                                                </>
                                            }
                                        />
                                    </>
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={6}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        showEditIcon={!this.props.incident?.isArchived}
                                        label="Description"
                                        fieldName="description"
                                        fieldDescription={fieldDescriptions?.description}
                                        showCopyIcon={false}
                                        inputType="textarea"
                                        error={this.state.fieldErrors?.description || null}
                                        isEditing={this.state.editField === "description"}
                                        isLoading={!!this.state.fieldLoading.description}
                                        inputValue={this.state.inputValues.description || this.props.incident?.description ? this.state.inputValues.description || this.props.incident?.description : null}
                                        currentValue={this.props.incident?.description}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            {defaultPartyDriver && (
                                <Row className='mt-2'>
                                    <CustomInputField
                                        colSize={12}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        label="Driver Statement"
                                        fieldName="driverStatement"
                                        showCopyIcon={false}
                                        inputType="textarea"
                                        error={this.state.fieldErrors?.driverStatement || null}
                                        isEditing={this.state.editField === "driverStatement"}
                                        isLoading={!!this.state.fieldLoading.driverStatement}
                                        inputValue={this.state.inputValues.driverStatement}
                                        currentValue={defaultPartyDriver.statement}
                                        onEdit={this.editField}
                                        onSave={(fieldName, fieldValue) => this.updateDriverStatement(defaultPartyDriver.id, fieldValue)}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                </Row>
                            )}
                        </div>
                    </Col >
                </Row >
                <Row className='mt-4'>
                    <Col xs={6} className="pb-2">
                        <div className='overview-external-card'>
                            <div className='overview-external-card__header'>
                                <div className='overview-external-card__eyebrow'>Driver Activity</div>
                                <h4 className='overview-external-card__title'>Argyle Gigs</h4>
                                <div className='overview-external-card__meta'>
                                    {this.props.incident?.incidentDate || "--"} {this.props.incident?.incidentTime ? `at ${this.props.incident.incidentTime}` : ""}
                                </div>
                            </div>
                            <div className='overview-external-card__body'>
                                {/* {this.props.incident?.rental?.driver?.id && this.props.incident?.incidentDate && */}
                                <RenderArgyleGigs driverId={driver?.id} incidentDate={this.props.incident?.incidentDate} incidentTime={this.props.incident?.incidentTime} showAll />
                                {/* } */}
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} className="pb-2">
                        <div className='overview-external-card'>
                            <div className='overview-external-card__header'>
                                <div className='overview-external-card__eyebrow'>Rideshare Incident Feed</div>
                                <h4 className='overview-external-card__title'>Uber Accidents</h4>
                                <div className='overview-external-card__meta'>
                                    {this.props.incident?.incidentDate || "--"}
                                </div>
                            </div>
                            <div className='overview-external-card__body'>
                                <RenderUberAccidents vin={this.props.incident?.car?.vin} incidentDate={this.props.incident?.incidentDate} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs={12}>
                        <div className={`overview-detail-grid ${true ? "overview-detail-grid--three" : "overview-detail-grid--two"}`}>
                            <div className="overview-detail-card">
                                <div className="overview-detail-card__header">
                                    <div>
                                        <div className="overview-detail-card__eyebrow">Vehicle</div>
                                        <div className="overview-detail-card__title">{carDisplayName}</div>
                                    </div>
                                    {car?.pk && (
                                        <Link className="overview-detail-card__link" to={'/car/' + car.pk} target="_blank">
                                            Open <i className="fa fa-external-link" />
                                        </Link>
                                    )}
                                </div>
                                <div className="overview-detail-card__meta">
                                    <span className="overview-detail-card__meta-pill">{car?.plate?.dmvPlate || "---"}</span>
                                    {car?.plate?.fhv && <span className="overview-detail-card__meta-pill">FHV {car.plate.fhv}</span>}
                                    <span className="overview-detail-card__meta-pill">{car?.branch?.name || "--"}</span>
                                </div>
                                <div className="overview-detail-card__stats">
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">VIN</span>
                                        <span className="overview-detail-card__stat-value columnContent">{car?.vin || "--"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Group</span>
                                        <span className="overview-detail-card__stat-value">{car?.carModel?.groupType?.name || "--"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Color</span>
                                        <span className="overview-detail-card__stat-value">{car?.color || "--"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Model</span>
                                        <span className="overview-detail-card__stat-value">
                                            {car?.carModel ? `${toTitleCase(car?.carModel?.make || "--")} ${toTitleCase(car?.carModel?.name || "--")}` : "--"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="overview-detail-card">
                                <div className="overview-detail-card__header">
                                    <div>
                                        <div className="overview-detail-card__eyebrow">Driver</div>
                                        <div className="overview-detail-card__title">{driver?.name || "---"}</div>
                                    </div>
                                    {driver?.id &&
                                        <Link className="overview-detail-card__link" to={'/driver/' + driver.id} target="_blank">
                                            Open <i className="fa fa-external-link" />
                                        </Link>
                                    }
                                </div>
                                <div className="overview-detail-card__meta">
                                    {driver?.currentAgreement?.id && <>
                                        <span className="overview-detail-card__meta-pill success" id="currentAgreementInfo">Active</span>
                                        <UncontrolledTooltip placement="top" target="currentAgreementInfo">Driver has an active agreement.</UncontrolledTooltip>
                                    </>}
                                    <span className="overview-detail-card__meta-pill">{driver?.branch?.name || "---"}</span>
                                    <span className="overview-detail-card__meta-pill">{driverInvoiceDay}</span>
                                </div>
                                <div className="overview-detail-card__stats">
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Phone</span>
                                        <span className="overview-detail-card__stat-value columnContent">{driver?.phone || "---"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Email</span>
                                        <span className="overview-detail-card__stat-value columnContent">{driver?.email || "---"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">DMV</span>
                                        <span className="overview-detail-card__stat-value columnContent">{driver?.dmvLicense || "---"}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">TLC</span>
                                        <span className="overview-detail-card__stat-value columnContent">{driver?.tlcLicense || "---"}</span>
                                    </div>
                                </div>
                                {this.state.openModal === "updateIncidentDriver" &&
                                    <UpdateIncidentInfo
                                        title="Edit Incident Driver"
                                        name="driverId"
                                        type="select"
                                        open={true}
                                        value={this.props.incident?.driver?.id || ""}
                                        currentOption={driver ? {
                                            label: driver.name || "---",
                                            pk: driver.pk,
                                            phone: driver.phone,
                                            email: driver.email,
                                            tlcLicense: driver.tlcLicense,
                                            branchName: driver.branch?.name,
                                        } : null}
                                        branchId={this.props.incident?.branch?.id}
                                        target="updateIncidentDriver"
                                        handleClose={() => this.toggleModal("")}
                                        incidentId={this.props.incident?.id}
                                        refetchIncident={() => {
                                            this.props.overviewTabRefetchQuery()
                                            if (this.props.refetchQuery) {
                                                this.props.refetchQuery()
                                            }
                                        }}
                                    />}
                            </div>

                            <div className="overview-detail-card">
                                <div className="overview-detail-card__header">
                                    <div>
                                        <div className="overview-detail-card__eyebrow">Agreement</div>
                                        <div className="overview-detail-card__title">#{rental?.pk || "--"}</div>
                                    </div>
                                    {((!rental || (agreementDateMismatch.isApplicable && agreementDateMismatch.hasMismatch)) && this.props.incident?.incidentDate) && <>
                                        <Button className='primary overview-detail-card__action' onClick={() => this.toggleModal("updateIncidentRental")} style={{ cursor: "pointer" }} id="updateIncidentRental">
                                            {!rental ? <i className="fa fa-plus" /> : <i className="fa fa-pencil" />}
                                        </Button>
                                        <UncontrolledTooltip placement="top" target="updateIncidentRental">{!rental ? "Add" : "Edit"} Rental</UncontrolledTooltip>
                                    </>}

                                </div>
                                <div className="overview-detail-card__meta">
                                    <span className="overview-detail-card__meta-pill">{toTitleCase(rental?.agreementType) || "--"}</span>
                                    <span className="overview-detail-card__meta-pill">{formatDuration(rental?.duration) || "--"}</span>
                                    <span className="overview-detail-card__meta-pill">{rental?.branch?.name || "No Rental Branch"}</span>
                                </div>
                                <div className="overview-detail-card__stats">
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Start Date</span>
                                        <span className="overview-detail-card__stat-value">
                                            {rental?.startDate ? <DatetimeRenderer datetime={rental.startDate} driverId={driver?.id || null} /> : "--"}
                                        </span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">End Date</span>
                                        <span className="overview-detail-card__stat-value">
                                            {rental?.endDate ? <DatetimeRenderer datetime={rental.endDate} driverId={driver?.id || null} /> : "--"}
                                        </span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Deposit</span>
                                        <span className="overview-detail-card__stat-value">{rentalDepositLabel}</span>
                                    </div>
                                    <div className="overview-detail-card__stat">
                                        <span className="overview-detail-card__stat-label">Split Agreement</span>
                                        <span className="overview-detail-card__stat-value">
                                            {rental?.splitAgreement?.driver ? (
                                                <>
                                                    {rental.splitAgreement.driver.name || "---"}{" "}
                                                    <Link color="primary" to={'/driver/' + rental.splitAgreement.driver.id} target="_blank">
                                                        <i className="fa fa-external-link" />
                                                    </Link>
                                                </>
                                            ) : "---"}
                                        </span>
                                    </div>
                                </div>
                                {this.state.openModal === "updateIncidentRental" &&
                                    <UpdateIncidentInfo
                                        title="Edit Incident Rental"
                                        name="rentalId"
                                        type="select"
                                        open={true}
                                        value={rental?.id || ""}
                                        carPk={car?.pk}
                                        incidentDate={this.props.incident?.incidentDate}
                                        target="updateIncidentRental"
                                        handleClose={() => this.toggleModal("")}
                                        incidentId={this.props.incident?.id}
                                        refetchIncident={this.props.overviewTabRefetchQuery}
                                    />
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs={8} className="pb-2">
                        <div className='info-container overview-panel-card overview-panel-card--table' style={{ maxHeight: 300, overflowY: 'auto' }}>
                            <div className='overview-panel-card__header'>
                                <div>
                                    <div className='overview-section-heading__eyebrow'>Billing</div>
                                    <h4 className='overview-section-heading__title'>Damage Transaction</h4>
                                </div>
                            </div>
                            <Table responsive className="overview-soft-table overview-soft-table--transaction">
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 500 }}>ID</th>
                                        <th style={{ fontWeight: 500 }}>Date Added</th>
                                        <th style={{ fontWeight: 500 }}>Charge Type</th>
                                        <th style={{ fontWeight: 500 }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.incident?.damageTransaction ?
                                        <>
                                            {this.state.openModal === ("TransactionInfo" + this.props.incident?.damageTransaction.pk) && (
                                                <TransactionInfo
                                                    id={this.props.incident?.damageTransaction.id}
                                                    refetchQuery={this.props.overviewTabRefetchQuery}
                                                    handleClose={() => this.toggleModal("TransactionInfo" + this.props.incident?.damageTransaction.pk)}
                                                    open={this.state.openModal === ("TransactionInfo" + this.props.incident?.damageTransaction.pk)}
                                                    currentUser={this.props.currentUser}
                                                />
                                            )}
                                            <tr>
                                                <td>
                                                    <div className="overview-inline-main">{this.props.incident?.damageTransaction.pk}</div>
                                                </td>
                                                <td>
                                                    <div className="overview-inline-main">
                                                        {this.props.incident?.damageTransaction.dateAdded ? <DatetimeRenderer datetime={this.props.incident?.damageTransaction.dateAdded} placement="right" /> : "---"}
                                                    </div>
                                                </td>
                                                <td onClick={() => this.toggleModal("TransactionInfo" + this.props.incident?.damageTransaction.pk)} style={{ cursor: "pointer" }}>
                                                    <div className="overview-inline-main">{this.props.incident?.damageTransaction.chargeType ? this.props.incident?.damageTransaction.chargeType.name : "---"}</div>
                                                    <div className="overview-inline-subtle">{this.props.incident?.damageTransaction.notes || "No notes added"}</div>
                                                </td>
                                                <td>
                                                    <div className="overview-amount-pill">
                                                        ${this.props.incident?.damageTransaction?.linkedPaymentPlan?.resultantTransactionsSum || this.props.incident?.damageTransaction.updates?.edges?.find(txn => txn.node.linkedPaymentPlan)?.node?.linkedPaymentPlan?.resultantTransactionsSum || (this.props.incident?.damageTransaction.dynamicAmount ? this.props.incident?.damageTransaction.dynamicAmount : "---")}
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                        : <tr><td colSpan={4}><div className="overview-empty-state">No Damage Transactions Found!</div></td></tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={4} className="pb-2">
                        <div className='info-container overview-panel-card'>
                            <div className='overview-panel-card__header overview-panel-card__header--actions'>
                                <div>
                                    <div className='overview-section-heading__eyebrow'>External References</div>
                                    <h4 className='overview-section-heading__title'>Legacy Systems</h4>
                                </div>
                                <div>
                                    <Button color="primary" className="align-middle" id={`addLegacySystemTooltip`} onClick={() => this.toggleModal("editLegacySystem-new")}>
                                        <i className='fa fa-plus' aria-hidden="true" />
                                        <UncontrolledTooltip target={`addLegacySystemTooltip`}>
                                            Add Legacy System
                                        </UncontrolledTooltip>
                                    </Button>
                                    {this.state.openModal === "editLegacySystem-new" &&
                                        <AddExternalSystem
                                            incidentId={this.props.incident?.id}
                                            openModal={this.state.openModal === "editLegacySystem-new"}
                                            handleClose={() => this.toggleModal("")}
                                            systems={[{ systemName: "", systemId: "" }]}
                                            isUpdate={false}
                                            refetchQuery={this.props.overviewTabRefetchQuery}
                                        />
                                    }
                                </div>
                            </div>
                            <div className="overview-legacy-grid">
                                {mondayItemId && this.props.hasPermissions?.includes("custom_can_view_import_source") && <div className="overview-legacy-card overview-legacy-card--source">
                                    <div className="overview-legacy-card__header">
                                        <div className="overview-legacy-card__title">Synced From Monday</div>
                                        <a className='overview-detail-card__link' target="_blank" rel='noopener noreferrer' href={mondayItemId ? `https://voyagm.monday.com/boards/8042244172/views/182369218/pulses/${mondayItemId}` : "#"}>
                                            Open <i className='fa fa-external-link' style={{ fontSize: 12 }} />
                                        </a>
                                    </div>
                                    <div className="overview-legacy-card__value">{mondayRowTitle || "--"}</div>
                                </div>}
                                {mondayItemId_1 && this.props.hasPermissions?.includes("custom_can_view_import_source") && <div className="overview-legacy-card overview-legacy-card--source">
                                    <div className="overview-legacy-card__header">
                                        <div className="overview-legacy-card__title">Synced From Monday</div>
                                        <a className='overview-detail-card__link' target="_blank" rel='noopener noreferrer' href={mondayItemId_1 ? `https://voyagm.monday.com/boards/8042244172/views/182369218/pulses/${mondayItemId_1}` : "#"}>
                                            Open <i className='fa fa-external-link' style={{ fontSize: 12 }} />
                                        </a>
                                    </div>
                                    <div className="overview-legacy-card__value">{mondayRowTitle_1 || "--"}</div>
                                </div>}
                                {crmId && this.props.hasPermissions?.includes("custom_can_view_import_source") && <div className="overview-legacy-card overview-legacy-card--source">
                                    <div className="overview-legacy-card__header">
                                        <div className="overview-legacy-card__title">Synced From CRM</div>
                                        <a className='overview-detail-card__link' target="_blank" rel='noopener noreferrer' href={crmId ? `https://fasttrackleasingllc.crm.dynamics.com/main.aspx?appid=6fd45022-0b56-483c-9dce-7223baf3331e&forceUCI=1&pagetype=entityrecord&etn=cf_incident&id=${crmId}` : "#"}>
                                            Open <i className='fa fa-external-link' style={{ fontSize: 12 }} />
                                        </a>
                                    </div>
                                    <div className="overview-legacy-card__value">{crmTitle || "--"}</div>
                                </div>}
                                {(this.props.incidentLoading && !this.props.incident) ? <Skeleton count={2} height={72} className="w-100" /> :
                                    Object.entries(externalSystems).length > 0 ? Object.entries(externalSystems).filter(([systemName, systemId]) => !crmId || systemName !== "CRM").map(([systemName, systemId], index) => (
                                        <div key={`system-${index}`} className="overview-legacy-card">
                                            <div className="overview-legacy-card__header">
                                                {console.log("Object.entries(externalSystems)", Object.entries(externalSystems))}
                                                <div className="overview-legacy-card__title">{systemName}</div>
                                                {!this.props.incident?.isArchived && (
                                                    <button
                                                        type="button"
                                                        className="overview-legacy-card__edit"
                                                        aria-label={`Edit legacyId-${index}`}
                                                        title={`Edit ${systemName}`}
                                                        onClick={() => this.toggleModal(`editLegacySystem-${systemName}`)}
                                                    >
                                                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </div>
                                            <div className="overview-legacy-card__value columnContent">{systemId || "--"}</div>
                                            {this.state.openModal === `editLegacySystem-${systemName}` && (
                                                <AddExternalSystem
                                                    incidentId={this.props.incident?.id}
                                                    openModal={this.state.openModal === `editLegacySystem-${systemName}`}
                                                    handleClose={() => this.toggleModal("")}
                                                    systems={[{ systemName, systemId }]}
                                                    isUpdate={true}
                                                    refetchQuery={this.props.overviewTabRefetchQuery}
                                                />
                                            )}
                                        </div>
                                    )) : !mondayItemId ? <div className="overview-empty-state">No Legacy Systems Found</div> : null
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs="12" className="pb-2">
                        <div className='info-container overview-panel-card overview-panel-card--table'>
                            <div className='overview-panel-card__header'>
                                <div>
                                    <div className='overview-section-heading__eyebrow'>Vehicle Damage</div>
                                    <h4 className='overview-section-heading__title'>Incident Damages</h4>
                                </div>
                            </div>
                            <Table responsive className="overview-soft-table overview-soft-table--damages">
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 500 }}>#</th>
                                        {ISSUES_TABLE.map(tableHeader =>
                                            <th key={tableHeader.id} style={{ fontWeight: 500 }}>{tableHeader.name}</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.incident?.incidentdamageSet?.edges?.length > 0 ? (
                                        <>
                                            {this.props.incident?.incidentdamageSet?.edges?.map((incidentDamage, i) => (
                                                <tr key={`incidentDamage__${i}`}>
                                                    <td scope="row" className="incident-listing-checkbox-wrapper">
                                                        {!this.state.selectedDamages.includes(incidentDamage.node.id) && <span className="listing-counter">{i + 1}</span>}
                                                        <span className="listing-checkbox" onClick={() => this.handleDamageSelection(incidentDamage.node.id)}>
                                                            {this.state.selectedDamages.includes(incidentDamage.node.id) ? <i className="fa fa-check-square-o" aria-hidden="true"></i> : <i className="fa fa-square-o unchecked" aria-hidden="true"></i>}
                                                        </span>
                                                    </td>
                                                    <td><div className="overview-inline-main">{incidentDamage.node.damage.dateAdded ? <DatetimeRenderer datetime={incidentDamage.node.damage.dateAdded} placement="right" /> : "---"}</div></td>
                                                    <td><div className="overview-inline-main">{incidentDamage.node.damage && incidentDamage.node.damage.issueCategory ? incidentDamage.node.damage.issueCategory.name : "NO CATEGORY SELECTED"}</div></td>
                                                    <td><span className="overview-status-pill">{incidentDamage.node.damage.status ? incidentDamage.node.damage.status : "---"}</span></td>
                                                    <td><div className="overview-inline-main">{incidentDamage.node.damage.projectedCost ? `$${incidentDamage.node.damage.projectedCost}` : "---"}</div></td>
                                                    <td><span className="overview-severity-pill">{this.props?.carIssueSeverityLevels?.enumValues?.find(item => item.name === incidentDamage.node.damage.severity)?.description || '---'}</span></td>
                                                    <td><div className="overview-inline-main">{incidentDamage.node.damage.canPickup ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</div></td>
                                                    <td>
                                                        {incidentDamage.node.damage.pictures && incidentDamage.node.damage.pictures.edges && incidentDamage.node.damage.pictures.edges.length > 0 ?
                                                            <div className="overview-picture-link" onClick={() => this.viewPictures(incidentDamage.node.damage.pictures.edges)}>
                                                                <i className="fa fa-file-image-o fa-lg" aria-hidden="true"></i>
                                                                <span>{incidentDamage.node.damage.pictures.edges.length > 1 ? `+${incidentDamage.node.damage.pictures.edges.length - 1} more` : "View"}</span>
                                                            </div> :
                                                            <div className="overview-inline-subtle">No Pictures Found</div>}
                                                    </td>
                                                    <td>
                                                        <button type="button" className="overview-icon-button" id={"editCarIssue" + i} onClick={() => this.setState({ openModal: "editCarIssue" + i })}>
                                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                        </button>
                                                        {this.state.openModal === "editCarIssue" + i && <CarIssueModal open={this.state.openModal === "editCarIssue" + i} isUpdate carIssue={incidentDamage.node.damage} handleClose={() => this.toggleModal("editCarIssue" + i)} refetchQuery={this.props.overviewTabRefetchQuery} />}
                                                        <UncontrolledTooltip target={"editCarIssue" + i}>Edit Car Issue</UncontrolledTooltip>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr><td colSpan="9"><div className="overview-empty-state">No Damages Found!</div></td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
                {crmNotes.length > 0 &&
                    <Row className='mt-4'>
                        <Col xs="12" className="pb-2">
                            <div className='info-container overview-panel-card'>
                                <div className='overview-panel-card__header'>
                                    <div>
                                        <div className='overview-section-heading__eyebrow'>Imported From CRM</div>
                                        <h4 className='overview-section-heading__title'>CRM Notes</h4>
                                    </div>
                                </div>
                                <div className="overview-crm-notes-list">
                                    {crmNotes.map((note, index) => (
                                        <div key={`crm-note-${index}`} className="overview-crm-note-card">
                                            <div className="overview-crm-note-card__meta">
                                                <span className="overview-crm-note-card__author" title="Created By">{note.created_by || "--"}</span>
                                                {note.modified_by && note.modified_by !== note.created_by &&
                                                    <span className="overview-crm-note-card__modified-by">
                                                        Modified by {note.modified_by}
                                                    </span>
                                                }
                                                <span className="overview-crm-note-card__date">
                                                    {note.created_on ? moment.unix(note.created_on).format("MMM D, YYYY hh:mm A") : "--"}
                                                </span>
                                            </div>
                                            {note.subject &&
                                                <div className="overview-crm-note-card__subject" title="Subject">{note.subject}</div>
                                            }
                                            <div className="overview-crm-note-card__body" title="Comment">{note.comment}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                }
            </div>
        )
    }
}

export default graphql(IncidentDetailQuery, {
    options: ({ id }) => ({
        variables: { incidentId: id },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { incident, loading, refetch, variables, ridesharePlatformChoices, ridesharePeriodChoices, ridesharePeriodSourceChoices, responsiblePartyChoices, sourceChoices, statusChoices, reportedByChoices, carIssueSeverityLevels, incidentTypeChoices, carTotaledChoices, incidentNodeFieldDescriptions, branchOptions } }) => ({
        incident,
        incidentLoading: loading,
        variables,
        ridesharePlatformChoices,
        ridesharePeriodChoices,
        ridesharePeriodSourceChoices,
        responsiblePartyChoices,
        sourceChoices,
        statusChoices,
        reportedByChoices,
        carIssueSeverityLevels,
        incidentTypeChoices,
        carTotaledChoices,
        incidentNodeFieldDescriptions,
        branchOptions,
        overviewTabRefetchQuery: () => {
            return refetch({
                ...variables,
            })
        },
    }),
})(graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["custom_can_edit_car_on_hold", "custom_can_view_import_source", "custom_can_change_incident_branch", "change_incident_sensitive_data"] },
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(withApolloClient(OverviewTab)))
